// GeneralStepBody.jsx

import React from "react";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 19 de 05 de 2026
 */

const GeneralStepBody = ({t, title = '', description = '', children}) => {
    return (
        <div className='d-flex flex-column align-items-center w-100 px-1 align-content-center justify-content-center h-90 '>
            <p className='fs-36px ibl-font-w-700 font-color-general-950 text-center mb-5'>{t(title)}</p>
            <p className='fs-16px ibl-font-w-400 font-color-shades-700 w-75 text-center mb-4'>{t(description)}</p>
            <div className={"px-0 px-xxl-5 w-75"}>
                {children}
            </div>
        </div>
    );
};

export default GeneralStepBody;
